import React from 'react';

const WappIcon = () => (
  <svg width="12" height="27" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 11.675l.24-1.192S5.4 7.386 8.16 9.53c1.44 1.073 1.92 2.383 1.08 5.242-.6 1.906-1.68 5.838-1.92 6.79-.36 1.43.24 3.575 4.2 1.907l-.24 1.43s-3 2.144-5.64 1.667c-.84-.119-1.56-.476-2.16-.834-1.44-.953-2.28-2.74-1.8-4.408 0-.119 1.92-7.028 1.92-7.028S5.28 9.888 0 11.675zM8.52 0c-1.8 0-3.36 1.43-3.36 3.097 0 1.668 1.56 3.098 3.36 3.098 1.8 0 3.48-1.31 3.48-3.098C12 1.31 10.44 0 8.52 0z" />
  </svg>
);

export default WappIcon;
